import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PhoneNumberOption, PhoneNumberOptionType, PhoneNumberOptionTypeMap } from '../select-phone-number';
import { SelectPhoneNumberDialogComponent, SelectPhoneNumberDialogData } from '../select-phone-number-dialog/select-phone-number-dialog.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-select-phone-number',
    templateUrl: './select-phone-number.component.html',
    styleUrl: './select-phone-number.component.sass',
    standalone: false
})
export class SelectPhoneNumberComponent {

  from = input<string | undefined>(undefined)

  selected = output<PhoneNumberOption>();

  type = input<PhoneNumberOptionType>(PhoneNumberOptionTypeMap.TWILIO);

  constructor(private dialog: MatDialog) { }

  openDialog() {

    const ref = this.dialog.open<SelectPhoneNumberDialogComponent, SelectPhoneNumberDialogData, PhoneNumberOption | undefined>(SelectPhoneNumberDialogComponent, {
      data: {
        from: this.from(),
        type: this.type(),
      },
    });

    ref.afterClosed().subscribe((option) => {

      if (option) {

        this.selected.emit(option);

      }

    });

  }

}
